export default {
  settings: {
    hasOvertime: true
  },
  actionTypes: {

  },
  modules: {
    info: [
      'timer',
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      score: ingameData => ingameData.score
    },
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    getOvertimePeriodName: () => 'OT',
    formatTitle: 'min5AndOvertime'
  }
}
